import type { NetworkMonitor } from "@bundle/core";
import { onlineManager } from "@tanstack/query-core";

// TanStack assumes "online" until an event fires; start from the browser's view so an app opened offline
// pauses queries/mutations immediately (navigator.onLine === false is reliable; true may be optimistic).
if (typeof navigator !== "undefined" && navigator.onLine === false) onlineManager.setOnline(false);

/** Network reachability from TanStack's onlineManager (browser online/offline events). */
export const networkMonitor: NetworkMonitor = {
  subscribe: (listener) => onlineManager.subscribe(() => listener()),
  getSnapshot: () => onlineManager.isOnline(),
};
